"use strict";

require("core-js/modules/es6.object.define-property");

Object.defineProperty(exports, "__esModule", {
  value: true
});

var error_1 = require("../../palette/error");

exports.overrides = {
  root: {
    '&$error': {
      backgroundColor: error_1["default"].light
    }
  }
};
exports.props = {};